module.exports = __webpack_public_path__ + "img/1.57efcdf8.jpg";